import React, { Component } from 'react';
import {Col, Row} from 'react-bootstrap';
import Tooltip from '@material-ui/core/Tooltip';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import IconButton from '@material-ui/core/IconButton';
import Button from '../../../components/button';
import ComponentErrorBoundary from '../../../components/component-error-boundary';

import {connect} from 'react-redux';
import {isValidPassword, MAX_LENGTH, REQUIREMENT_TEXT} from '../../../util/password-policy';



class AddUser extends Component {

  constructor(props) {
    super(props);
    this.state = {
      userId:this.props.userData.user.userID,
      userName:this.props.userData.user.name,
      userEmail:this.props.userData.user.email,
      nameErrorStatus:false,
      nameErrorText:"",
      emailErrorStatus:false,
      emailErrorText:"",
      newPassword:"",
      newPasswordErrorStatus:false,
      showNewPassword:false,
      newPasswordErrorText:"",
      confirmPassword:"",
      confirmPasswordErrorStatus:false,
      confirmPasswordErrorText:"",
      showConfirmPassword:false,
      saveButtonStatus:true,
      formErrorState:['userName','userEmail','newPassword','confirmPassword']
    };
  }


  componentDidUpdate(prevProps) {
  if (this.props.userData !== prevProps.userData) {
    this.setState({
      userId:this.props.userData.user.userID,
      userName:this.props.userData.user.name,
      userEmail:this.props.userData.user.email,
      newPassword:"",
      newPasswordErrorStatus:false,
      newPasswordErrorText:"",
      confirmPassword:"",
      confirmPasswordErrorStatus:false,
      confirmPasswordErrorText:"",
      saveButtonStatus:true,
      formErrorState:['userName','userEmail','newPassword','confirmPassword']
    })
  }
 }

 cancelFlow=()=>{
    this.props.cancelFlow();
 }

 saveFlow=()=>{

   let userObj={
     name: this.state.userName,
     email: this.state.userEmail,
     password:this.state.newPassword,
     orgId: Number(this.props.orgId)
   }

   this.props.saveFlow(userObj,'new',this.state.userName);
 }

  handleTextfield = (event,item) => {
      this.setState({[item]:event.target.value});
  }


  formErrorRemoveValue=(attr)=>{
    if (this.state.formErrorState.find(o => o === attr)){
      this.setState({formErrorState:this.state.formErrorState.filter(val=> val !== attr)});
    }
  }

  formErrorInsertValue=(attr)=>{
    if (!this.state.formErrorState.find(o => o === attr)){
      this.setState({formErrorState:[...this.state.formErrorState,attr]});
    }
  }


  validateName=()=>{

    if(this.state.userName.length>2)
    {

      this.formErrorRemoveValue('userName');
      this.setState({nameErrorStatus:false,nameErrorText:""},()=>{this.enableSaveButton();});
      return true;
    }
    else{

      this.formErrorInsertValue('userName');
      this.setState({nameErrorStatus:true,nameErrorText:"Please enter a valid name."},()=>{this.enableSaveButton();});
      return false;
    }

  }

  validateEmail=()=>{

    if(this.state.userEmail.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/))
    {

      this.formErrorRemoveValue('userEmail');
      this.setState({emailErrorStatus:false,emailErrorText:""},()=>{this.enableSaveButton();});
      return true;
    }
    else{
      this.formErrorInsertValue('userEmail');
      this.setState({emailErrorStatus:true,emailErrorText:"Please enter a valid email address."});
      return false;
    }
  }

  checkPasswordStrength=()=>{
    if(this.state.newPassword.length > 0){
      // Was /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{8,16}$/ — alphanumeric ONLY, so it silently
      // rejected every symbol while the requirement list beside it said nothing about that. It also
      // disagreed with profile.js, which allowed any character. One shared rule now; see
      // src/util/password-policy.js.
      if(isValidPassword(this.state.newPassword))
        {
        this.formErrorRemoveValue('newPassword');
        this.setState({newPasswordErrorStatus:false,newPasswordErrorText:""},()=>{this.enableSaveButton();});
        return true;
        }
      else
        {
        this.formErrorInsertValue('newPassword');
        this.setState({newPasswordErrorStatus:true,newPasswordErrorText:"Password is not matching the requirements. Please check."},()=>{this.enableSaveButton();});
        return false;
        }

      }
  }

  checkPasswordMatch=()=>{
    if(this.state.newPassword !== this.state.confirmPassword){
      this.formErrorInsertValue('confirmPassword');
      this.setState({confirmPasswordErrorStatus:true,confirmPasswordErrorText:"Passwords didn't match. Please check."},()=>{this.enableSaveButton();});
    }
    else{
      this.formErrorRemoveValue('confirmPassword');
      this.setState({confirmPasswordErrorStatus:false,confirmPasswordErrorText:""},()=>{this.enableSaveButton();});
    }
  }

  enableSaveButton=()=>{
    if(this.state.formErrorState.length===0)
      {
      this.setState({saveButtonStatus:false});
      } else{
      this.setState({saveButtonStatus:true});
      }

}


handleClickShowPassword = (field) => {
    this.setState({[field]: !this.state[field] });
  };

 handleMouseDownPassword = (event) => {
    event.preventDefault();
  };






   render() {

     return (
       <div>

       <Row className='label-value-pair'>
         <Col sm={4} xs={12}>
        <ComponentErrorBoundary value="admin add user name">
         <FormControl fullWidth>
          <InputLabel htmlFor="standard-adornment-password">Name</InputLabel>
          <Input
            type="text"
            value={this.state.userName}
            onChange={(e)=>this.handleTextfield(e,"userName")}
            onBlur={this.validateName}
            error={this.state.nameErrorStatus}
          />
          <FormHelperText className="Mui-error">{this.state.nameErrorText}</FormHelperText>
         </FormControl>
         </ComponentErrorBoundary>
         </Col>
       </Row>

       <Row className='label-value-pair'>
         <Col sm={4} xs={12}>
         <ComponentErrorBoundary value="admin add user email">
         <FormControl fullWidth>
          <InputLabel htmlFor="standard-adornment-password">Email address</InputLabel>
          <Input
            type="email"
            value={this.state.userEmail}
            onChange={(e)=>this.handleTextfield(e,"userEmail")}
            onBlur={this.validateEmail}
            error={this.state.emailErrorStatus}
          />
          <FormHelperText className="Mui-error">{this.state.emailErrorText}</FormHelperText>
         </FormControl>
         </ComponentErrorBoundary>
         </Col>
       </Row>

       <Row className='label-value-pair'>
         <Col sm={4} xs={12}>
         <ComponentErrorBoundary value="admin add user enter password">
         <FormControl fullWidth>
          <InputLabel htmlFor="standard-adornment-password">Enter password</InputLabel>
          <Input
            type={this.state.showNewPassword ? 'text' : 'password'}
            value={this.state.newPassword}
            inputProps={{'maxLength': MAX_LENGTH, 'data-testid': 'adduser-new-password'}}
            autoComplete="new-password"
            onChange={(e)=>this.handleTextfield(e,"newPassword")}
            onBlur={this.checkPasswordStrength}
            error={this.state.newPasswordErrorStatus}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={()=>this.handleClickShowPassword('showNewPassword')}
                  onMouseDown={(e)=>this.handleMouseDownPassword(e)}
                >
                  {this.state.showNewPassword ? <Tooltip title="Hide" placement="right"><i className="material-icons">visibility</i></Tooltip> : <Tooltip title="Show" placement="right"><i className="material-icons">visibility_off</i></Tooltip>}
                </IconButton>
              </InputAdornment>
            }
          />
          <FormHelperText className="Mui-error">{this.state.newPasswordErrorText}</FormHelperText>
         </FormControl>
         </ComponentErrorBoundary>
           <div className='password-requirements'>
           <div className='title'>Password requirements:</div>
           <ul>
             <li>{REQUIREMENT_TEXT[0]}</li>
             <li>at least one uppercase and one lowercase character</li>
             <li>at least one number</li>
           </ul>
           </div>
         </Col>
       </Row>
       <Row className='label-value-pair'>
         <Col sm={4} xs={12}>
         <ComponentErrorBoundary value="admin add user re-enter password">
         <FormControl fullWidth>
          <InputLabel htmlFor="standard-adornment-password">Re-enter password</InputLabel>
          <Input
            type={this.state.showConfirmPassword ? 'text' : 'password'}
            value={this.state.confirmPassword}
            inputProps={{'maxLength': MAX_LENGTH, 'data-testid': 'adduser-confirm-password'}}
            onChange={(e)=>this.handleTextfield(e,"confirmPassword")}
            onBlur={this.checkPasswordMatch}
            error={this.state.confirmPasswordErrorStatus}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={()=>this.handleClickShowPassword('showConfirmPassword')}
                  onMouseDown={(e)=>this.handleMouseDownPassword(e)}
                >
                  {this.state.showConfirmPassword ? <Tooltip title="Hide" placement="right"><i className="material-icons">visibility</i></Tooltip> : <Tooltip title="Show" placement="right"><i className="material-icons">visibility_off</i></Tooltip>}
                </IconButton>
              </InputAdornment>
            }
          />
          <FormHelperText className="Mui-error">{this.state.confirmPasswordErrorText}</FormHelperText>
         </FormControl>
         </ComponentErrorBoundary>
         </Col>
       </Row>

       <Row>
       <Col sm={4} xs={12} className='text-right'>
        <Button label="Cancel" className='btn btn-default' onClick={this.cancelFlow.bind(this)} />

        <Button label="Save" className='btn btn-action' disabled={this.state.saveButtonStatus} onClick={this.saveFlow.bind(this)}  />

       </Col>

       </Row>


         </div>

     );
   }
}


const mapStateToProps = (state) => {
  return{
    isLoading: state.usersReducer.isLoading,
    errors: state.usersReducer.errorMessage
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {

  }
}


export default connect(mapStateToProps,mapDispatchToProps) (AddUser);
